import { useState } from "react";
import { Loader2, Mail, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { useAuth } from "../context/AuthContext";

// We always email the signed-in account address (the backend ignores any typed value), so show it read-only.
export const NotifyForm = ({ creation, onNotify }) => {
  const { user } = useAuth();
  const email = (user?.email || creation.notify_email || "").toLowerCase();
  const [saving, setSaving] = useState(false);
  const saved = !!creation.notify_email && creation.notify_email === email;

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await onNotify(email);
    setSaving(false);
  };

  return (
    <form onSubmit={submit} data-testid="notify-form" className="rounded-3xl border border-border bg-card/60 p-4">
      <p className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-accent mb-3">
        <Mail className="h-4 w-4" /> Email me when it's ready
      </p>
      <div className="flex gap-2">
        <Input
          type="email"
          readOnly
          data-testid="notify-email-input"
          value={email}
          title="We'll email your account address"
          className="rounded-full h-11 bg-muted/60 cursor-not-allowed text-muted-foreground"
        />
        <Button type="submit" data-testid="notify-submit-btn" disabled={saving || !email} className="rounded-full h-11 px-5 font-semibold gap-2">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : saved ? <Check className="h-4 w-4" /> : <Mail className="h-4 w-4" />}
          {saved ? "Saved" : "Notify me"}
        </Button>
      </div>
      <p className="mt-2 text-xs text-muted-foreground">
        {saved ? (
          <span data-testid="notify-confirmation">
            We'll send the download link to <span className="font-semibold">{email}</span>. You can close this tab.
          </span>
        ) : (
          <>
            We'll email your account address <span className="font-semibold">{email || "— sign in first"}</span>.
          </>
        )}
      </p>
    </form>
  );
};
